import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export const OLD_PORTAL_HOST = 'speccitystroy.online';
export const NEW_PORTAL_URL = 'https://portal.speccitystroy.ru';
export const MIGRATION_NOTICE_KEY = 'portal-domain-migration-2026-08-18';

interface DomainMigrationNoticeProps {
  currentHostname?: string;
}

const DomainMigrationNotice: React.FC<DomainMigrationNoticeProps> = ({
  currentHostname = window.location.hostname
}) => {
  const [show, setShow] = useState(() => {
    if (currentHostname !== OLD_PORTAL_HOST) {
      return false;
    }

    try {
      return sessionStorage.getItem(MIGRATION_NOTICE_KEY) !== 'dismissed';
    } catch {
      return true;
    }
  });

  const dismiss = () => {
    try {
      sessionStorage.setItem(MIGRATION_NOTICE_KEY, 'dismissed');
    } catch {
      // The notice remains dismissible when browser storage is unavailable.
    }
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onHide={dismiss}
      centered
      aria-labelledby="domain-migration-notice-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="domain-migration-notice-title">
          Корпоративный портал переезжает
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          С <strong>18 августа 2026 года</strong> сервис будет доступен по
          новому адресу:
        </p>
        <p className="mb-3">
          <a href={NEW_PORTAL_URL}>{NEW_PORTAL_URL}</a>
        </p>
        <p className="mb-0 text-muted">
          Пожалуйста, сохраните новый адрес в закладках. До даты перехода
          продолжайте работать по текущему адресу.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={dismiss}>
          Понятно
        </Button>
        <Button as="a" href={NEW_PORTAL_URL} variant="primary">
          Открыть новый адрес
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DomainMigrationNotice;
